import type { RootState } from '../../createStore'
import { crsApi } from './react'

export const selectCompanyListQueryResult = crsApi.endpoints.companyList.select()
export const selectDashboardListQueryResult = (state: RootState, groupId: string) =>
  crsApi.endpoints.dashboardList.select({ groupId })(state)
export const selectClientConfigurationQueryResult = crsApi.endpoints.clientConfiguration.select()
